import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { People } from '../shapes';


const PeopleSvg = (props) => (
  <g>
    <IconBounds />
    <People {...props} />
  </g>
);

PeopleSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

PeopleSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default PeopleSvg;
